import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { actionItemsData } from '../mockData/action-items-data';

const ActionItemsApi = [
  rest.get(`${API_ROOT}action-items`, (req, res, ctx) => {
    const limit = req.url.searchParams.get('limit');
    const skip = req.url.searchParams.get('skip');
    const providerId = req.url.searchParams.get('providerId');
    if (providerId && limit && skip) {
      return res(ctx.json(actionItemsData));
    }
    return res(
      ctx.json({
        total: '',
        limit: 10,
        skip: 0,
        data: [],
      }),
    );
  }),
];
export default ActionItemsApi;
